
export const CONTRACT_INFO_GET_REQUEST = 'CONTRACT_INFO_GET_REQUEST';
export const CONTRACT_INFO_GET_SUCCESS = 'CONTRACT_INFO_GET_SUCCESS';
export const CONTRACT_INFO_GET_ERROR = 'CONTRACT_INFO_GET_ERROR'; 
